<template>
  <div>
    <div class="container_room">
      <div class="chat_room">
        <div class="head_chat px-2 d-flex justify-space-between align-center">
          <div></div>
          <v-btn v-if="!isMemberShow" @click="showMember" icon
            ><v-icon>mdi-dots-horizontal</v-icon></v-btn
          >
        </div>
        <div class="temp_chat" v-if="allMsg">
          <v-overlay
            :absolute="true"
            color="white"
            opacity="1"
            :value="loadMsg"
          >
            <v-progress-circular
              indeterminate
              class="mr-2"
              color="#006341"
            ></v-progress-circular>
            <b class="color_default">Loading message</b>
          </v-overlay>
          <div class="pa-2" v-if="allMsg.length">
            <div v-for="(chat, n) in allMsg" :key="`chatke-${n}`">
              <div class="d-flex justify-center">
                <div
                  class="date_sparator my-2"
                  v-if="
                    n != 0 &&
                    $date(allMsg[n].created_at).format('YYYY MM DD') !==
                      $date(allMsg[n - 1].created_at).format('YYYY MM DD')
                  "
                >
                  <small>{{
                    $date(chat.created_at).format("YYYY-MM-DD") == today
                      ? "Today"
                      : $date(chat.created_at).format("YYYY-MM-DD") == yesterday
                      ? "yesterday"
                      : $date(chat.created_at).format("DD,MM,YYYY")
                  }}</small>
                </div>
                <div class="date_sparator my-2" v-else-if="n == 0">
                  <small>{{
                    $date(chat.created_at).format("YYYY-MM-DD") == today
                      ? "Today"
                      : $date(chat.created_at).format("YYYY-MM-DD") == yesterday
                      ? "Yesterday"
                      : $date(chat.created_at).format("DD,MM,YYYY")
                  }}</small>
                </div>
              </div>
              <div
                :id="chat.id"
                :class="chat.user_id == id ? 'my_temp' : 'your_temp'"
              >
                <div v-if="chat.user_id != id" class="temp_ava">
                  <v-avatar dark class="mr-2" size="35" v-if="n == 0">
                    <img
                      :src="chat.Profile ? chat.Profile : ava"
                      alt=""
                      class="obj_fit"
                    />
                  </v-avatar>
                  <v-avatar
                    dark
                    class="mr-2"
                    size="35"
                    v-else-if="n !== 0 && allMsg[n].name != allMsg[n - 1].name"
                  >
                    <img
                      :src="chat.Profile ? chat.Profile : ava"
                      class="obj_fit"
                      alt=""
                    />
                  </v-avatar>
                </div>
                <div :class="chat.user_id == id ? 'my_half' : 'your_half'">
                  <div style="color: #006341" v-if="chat.user_id != id">
                    <b class="name_sender" v-if="n == 0"> {{ chat.name }} </b>
                    <b
                      class="name_sender"
                      v-else-if="
                        n !== 0 && allMsg[n].name != allMsg[n - 1].name
                      "
                    >
                      {{ chat.name }}
                    </b>
                  </div>
                  <v-hover v-slot="{ hover }">
                    <div
                      :class="chat.user_id == id ? 'my_ballon' : 'your_ballon'"
                    >
                      <div>
                        <div
                          :class="chat.user_id == id ? 'my_reply' : 'ur_reply'"
                          v-if="chat.reply_id"
                        >
                          <p class="ma-0 mr-2" v-snip="3">
                            {{ chat.reply_message }}
                          </p>
                        </div>
                        <!-- <div v-if="chat.image">
                          <img
                            :src="chat.image"
                            @click="viewImage(chat)"
                            class="image_in_msj"
                            alt=""
                          />
                        </div> -->
                        <p class="ma-0 pre_format" v-html="chat.message"></p>
                      </div>
                      <div
                        class="d-flex justify-space-between align-end"
                        style="height: 28px"
                      >
                        <p class="default_txt">
                          {{ $date(chat.created_at).format("HH:mm") }}
                        </p>
                        <v-expand-x-transition
                          v-if="
                            permissions.includes('LD') ||
                            role == 'SUPERADMIN' ||
                            role == 'VENDOR'
                          "
                        >
                          <div class="d-flex justify-end" v-if="hover">
                            <v-card
                              class="temp_rpl d-flex align-center"
                              color="#f6f6f6"
                              flat
                            >
                              <v-btn icon small @click="replyChat(chat)">
                                <v-icon class="mr-1" small>mdi-reply</v-icon>
                              </v-btn>
                              <v-btn
                                icon
                                small
                                v-if="chat.user_id == id"
                                @click="deleteData(chat)"
                              >
                                <v-icon class="mr-1" small>mdi-delete</v-icon>
                              </v-btn>
                            </v-card>
                          </div>
                        </v-expand-x-transition>
                      </div>
                    </div>
                  </v-hover>
                </div>
                <div v-if="chat.user_id == id" class="temp_ava">
                  <v-avatar dark class="ml-2" size="35" v-if="n == 0">
                    <img
                      :src="chat.Profile ? chat.Profile : ava"
                      class="obj_fit"
                      alt=""
                    />
                  </v-avatar>
                  <v-avatar
                    dark
                    class="ml-2"
                    size="35"
                    v-else-if="n !== 0 && allMsg[n].name != allMsg[n - 1].name"
                  >
                    <img
                      :src="chat.Profile ? chat.Profile : ava"
                      alt=""
                      class="obj_fit"
                    />
                  </v-avatar>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="typing_pace" v-if="!permissions.includes('GUEST')">
          <div class="temp_reply pa-2" v-if="dataReply">
            <v-btn
              icon
              color="#6FA287"
              class="mt-1 mr-2"
              @click="dataReply = null"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <div class="strip_rep">
              <b class="name_sender"> {{ dataReply.name }} </b>
              <p class="default_txt" v-snip="1">{{ dataReply.message }}</p>
            </div>
          </div>
          <div class="d-flex pa-2">
            <!-- <v-btn icon color="#6FA287" class="mt-1 mr-2">
              <v-icon>mdi-paperclip</v-icon>
            </v-btn> -->
            <v-card flat outlined class="d-flex" style="width: 100%">
              <v-textarea
                class="typing rounded-lg pa-0"
                v-model="msg"
                rows="1"
                id="chat-message-typer-textarea"
                auto-grow
                row-height="10"
                :disabled="sending"
                placeholder="type message"
                solo
                @keydown.enter.exact.prevent="checkType('text')"
                @keydown.enter.shift.exact.prevent="msg += '\n'"
                flat
                ref="typist"
                hide-details
              ></v-textarea>
              <v-btn
                icon
                color="#6FA287"
                class="mt-1 mr-2"
                @click="checkType('text')"
                v-if="!sending"
              >
                <v-icon style="transform: rotate(-40deg)"
                  >mdi-send-outline</v-icon
                >
              </v-btn>
              <v-progress-circular
                v-if="sending"
                indeterminate
                size="25"
                class="mt-2 mr-2"
                color="#006341"
              ></v-progress-circular>
            </v-card>
          </div>
        </div>
      </div>
      <div class="list_person">
        <div class="head_chat_2 px-2 d-flex justify-end align-center">
          <v-btn @click="showMember" icon
            ><v-icon>mdi-dots-horizontal</v-icon></v-btn
          >
        </div>
        <div class="pa-3">
          <member-chat />
        </div>
      </div>
    </div>
    <div class="pa-1">
      <dialog-small
        :d_small="d_small"
        @close="d_small = false"
        @refetch="fetchData"
        :type="d_type"
        :inventory="inventory"
        :title="d_title"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import dialogSmall from "../dialog/dialogSmall.vue";
import MemberChat from "./memberChat.vue";
export default {
  components: { dialogSmall, MemberChat },
  name: "chatRoom",
  computed: {
    ...mapState({
      id: (state) => state.id,
      ava: (state) => state.ava,
      profile: (state) => state.profile,
      permissions: (state) => state.permissions,
      role: (state) => state.role,
    }),
  },
  data() {
    return {
      allMsg: null,
      loading: false,
      loadMsg: false,
      sending: false,
      typeMsg: "",
      msg: "",
      today: this.$date().format("YYYY-MM-DD"),
      yesterday: this.$date().subtract(1, "day").format("YYYY-MM-DD"),
      timestamp: this.$date(),
      d_create: false,
      d_large: false,
      d_small: false,
      d_type: "",
      d_title: "",
      inventory: null,
      dataReply: null,
      isMemberShow: false,
    };
  },
  mounted() {
    let vm = this;
    let course = vm.$route.params.idCourse;
    window.Echo.channel(`chat-${course}`).listen("ChatEvent", (e) => {
      console.log(e);
      if (e.chat_type == "send") {
        e.chat_data["name"] = e.chat_profile_user.name;
        vm.allMsg.push(e.chat_data);
        vm.scrollDown();
        vm.onFocused();
        vm.sending = false;
      } else if (e.chat_type == "delete") {
        vm.fetchData();
      }
    });

    this.fetchData(true);
    this.onFocused();
  },
  methods: {
    // focus ke text area
    onFocused() {
      setTimeout(() => {
        this.$refs["typist"].$refs.input.focus();
      }, 100);
    },
    fetchData(first) {
      if (first) {
        this.loadMsg = true;
      }
      let data = {
        path: `chat/${this.$route.params.idCourse}`,
      };
      this.$store.dispatch("chat/getData", data).then((data) => {
        this.allMsg = data.data;
        this.scrollDown();
        this.loadMsg = false;
        this.sending = false;
      });
    },
    checkType(type) {
      this.typeMsg = type;
      if (type == "text") {
        if (this.msg !== "") {
          this.sendMsg();
        }
      } else {
        this.sendMsg();
      }
    },
    replyChat(chat) {
      this.dataReply = chat;
      this.onFocused();
    },
    sendMsg() {
      this.sending = true;
      let body = {
        course_id: this.$route.params.idCourse,
        type: this.typeMsg,
        message: this.msg,
        reply_id: this.dataReply ? this.dataReply.chat_id : null,
      };
      let data = {
        path: `chat/send`,
        body: body,
      };
      this.$store
        .dispatch("chat/postApi", data)
        .then(() => {
          this.msg = "";
          this.dataReply = null;
          this.fetchData();
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.sending = false;
        });
    },
    scrollDown() {
      setTimeout(function () {
        let down = document.querySelector(".temp_chat");
        down.scrollTop = down.scrollHeight; //auto scroll bottom of page
      }, 100);
    },
    deleteData(item) {
      this.d_type = "d_msg";
      this.inventory = item;
      this.d_title = "Delete Message";
      this.d_small = true;
    },
    showMember() {
      this.isMemberShow = !this.isMemberShow;
      let chat = document.querySelector(".chat_room");
      let person = document.querySelector(".list_person");
      if (this.$vuetify.breakpoint.smAndDown) {
        if (this.isMemberShow) {
          person.style.width = "100%";
          chat.style.width = "0";
        } else {
          chat.style.width = "100%";
          person.style.width = "0";
        }
      } else {
        if (this.isMemberShow) {
          chat.style.width = "65%";
          person.style.width = "35%";
        } else {
          chat.style.width = "100%";
          person.style.width = "0";
        }
      }
    },
  },
};
</script>

<style scoped>
.date_sparator {
  background: rgb(35, 150, 35);
  border-radius: 5px;
  padding: 5px 10px;
  color: #fff;
}
.name_sender {
  font-size: 13px;
}
.container_room {
  display: flex;
  width: 100%;
  overflow: hidden;
  position: relative;
  border-radius: 10px;
}
.chat_room {
  position: relative;
  width: 100%;
  height: 90vh;
  background: #fff;
  transition: all 0.3s;
}
.list_person {
  overflow: hidden;
  width: 0;
  height: 90vh;
  z-index: 3;
  background: #fff;
  transition: all 0.3s;
}
.temp_ava {
  width: 43px;
}
.head_chat {
  height: 7vh;
  border-bottom: 1px solid #e3e1e1;
}
.head_chat_2 {
  height: 7vh;
  border-bottom: 1px solid #e3e1e1;
  border-left: 1px solid #e3e1e1;
}
.temp_chat {
  height: 73vh;
  overflow-y: scroll;
  scroll-behavior: smooth !important;
  scrollbar-width: thin;
}
.typing_pace {
  position: absolute;
  bottom: 0;
  width: 100%;
}
.typing {
  font-size: small;
  line-height: 1.6 !important;
}
.v-textarea textarea {
  line-height: 1.5 !important;
  margin-top: 15px !important;
}
/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #fff;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.temp_reply {
  display: flex;
  width: 100%;
  background: #f6f6f6;
}
.strip_rep {
  border-left: solid 3px #006341;
  padding: 2px 10px;
}
.pre_format {
  word-break: break-all;
  white-space: pre-wrap;
}

/* chatt */
.my_temp {
  padding: 5px;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  transition: 0.5s;
  /* margin-bottom: 10px; */
  border-radius: 5px;
}
.my_half {
  display: flex;
  justify-content: flex-end;
  width: 70%;
}
.my_ballon {
  position: relative;
  background: #006341;
  padding: 5px;
  border-radius: 10px 0 10px 10px;
  color: #fff;
  transition: 2s all !important;
  min-width: 200px;
  /* width: max-content; */
}
.ur_reply {
  word-break: break-all;
  white-space: pre-wrap;
  padding: 5px;
  cursor: pointer;
  background: #e4e3e3;
  border-left: solid 3px #006341;
  border-radius: 0 10px 0 0;
}
.my_reply {
  word-break: break-all;
  white-space: pre-wrap;
  padding: 5px;
  cursor: pointer;
  background: #078257;
  border-left: solid 3px #fff;
}
.your_temp {
  padding: 5px;
  display: flex;
  justify-content: flex-start;
  width: 100%;
  transition: 0.5s;
  border-radius: 5px;
}
.your_half {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 70%;
}
.your_ballon {
  position: relative;
  background: #f1f1f1;
  padding: 5px;
  border-radius: 0 10px 10px 10px;
  transition: 2s all !important;
  min-width: 200px;
}

@media (max-width: 1200px) {
}
@media (max-width: 925px) {
}
@media (max-width: 825px) {
}
@media (max-width: 768px) {
  .list_person {
    position: absolute;
    width: 100%;
  }
  .head_chat_2 {
    border-left: 1px #fff;
  }
}
@media (max-width: 576px) {
}
@media (max-width: 396px) {
  .temp_ava {
    display: none;
  }
}
</style>
